module.exports = __webpack_public_path__ + "static/loc_analysis-891a6fc1ddaa815742c0cc806bfa0068.png";